import { InjectionToken } from '@angular/core';
import { MobileApplicationAppConfig } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MOBILE_APPLICATION_APPS_CONFIG: InjectionToken<MobileApplicationAppConfig> =
  new InjectionToken<MobileApplicationAppConfig>('MobileApplicationAppConfig', {
    factory: () => ({})
  });
